<template>
  <a v-if="image" class="style-series-tile" :href="entry.onlineStoreUrl">
    <div class="style-series-tile__media-wrap">
      <img :src="image" :alt="imageAlt" class="style-series-tile__image" />
    </div>
    <div class="style-series-tile__content">
      <h3 class="style-series-tile__title">{{ entry.title }}</h3>
      <p v-if="entry.blurb" class="style-series-tile__blurb">
        {{ entry.blurb }}
      </p>
      <p v-if="entry.type" class="style-series-tile__type">
        {{ entry.type }}
      </p>
    </div>
  </a>
</template>

<script>
export default {
  name: "StyleSeriesTile",
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },
  computed: {
    image() {
      return this.entry?.image?.url || "";
    },
    imageAlt() {
      return this.entry?.image?.altText || this.entry.title;
    },
  },
};
</script>

<style lang="scss" scoped>
.style-series-tile {
  display: block;
  color: inherit;
  text-decoration: none;
}

.style-series-tile__media-wrap {
  width: 100%;
  aspect-ratio: 400 / 630;
  overflow: hidden;
  background: #f2f2f2;
}

.style-series-tile__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.style-series-tile__content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 20px;
  padding-right: 40px;

  @include respond-above(md) {
    padding-right: 80px;
  }
}

.style-series-tile__title,
.style-series-tile__blurb,
.style-series-tile__type {
  margin: 0;
}

.style-series-tile__title {
  @include editorial-body(14px);
  text-transform: uppercase;
  line-height: 1.5;
}

.style-series-tile__blurb,
.style-series-tile__type {
  @include editorial-body(14px);
  line-height: 1.5;
}

.style-series-tile__blurb {
  font-style: italic;
}

.style-series-tile__type {
  font-style: italic;
}
</style>
